// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_department,
  add_department,
  update_department,
  delete_department,
  get_department_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  departments: [],
  departmentlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    department_code: "",
  },
};

// Async Thunks for API Calls
export const fetchDepartmentList = createAsyncThunk(
    'department/fetchDepartmentlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_department_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchDepartment = createAsyncThunk(
  "department/fetchDepartment",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_department(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createDepartment = createAsyncThunk(
  "department/createDepartment",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_department(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateDepartment = createAsyncThunk(
  "department/updateDepartment",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_department(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDepartment = createAsyncThunk(
  "department/deleteClass",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_department({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const departmentSlice = createSlice({
  name: 'departments',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name,department_code } = action.payload;
      state.formData = { id, name,department_code };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        department_code:""
      };
    },
    setClass(state, action) {
      state.classes = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchDepartmentList.fulfilled, (state, action) => {
        state.departmentlist = action.payload.data;
      })
       // Fetch Classes
       .addCase(fetchDepartment.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.departments = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchDepartment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createDepartment.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateDepartment.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateDepartment.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteDepartment.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteDepartment.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setClass,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = departmentSlice.actions;
export default departmentSlice.reducer;
